import { render } from "./addNewCandidate.vue?vue&type=template&id=476ea235&ts=true"
import script from "./addNewCandidate.vue?vue&type=script&lang=ts"
export * from "./addNewCandidate.vue?vue&type=script&lang=ts"

import "./addNewCandidate.vue?vue&type=style&index=0&id=476ea235&lang=scss"

import exportComponent from "/codebuild/output/src2155066187/src/reference-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__